import {
  DataUiBlueprints,
  DataUiColumnDescription,
  SimplifiedRelationType,
} from '@gid/models';
import _ from 'lodash';
import { Vue } from 'vue-property-decorator';

export function makePath(current, next): string {
  if (typeof next === 'number') {
    next = next.toString();
    return `${current}[${next}]`;
  }
  if (current) {
    return `${current}.${next}`;
  }
  return next;
}

export function updateModelOnInput(value: any, $event) {
  const pathList = _.toPath($event.valuePath);
  let currentPath = pathList.shift();
  while (currentPath !== undefined && pathList.length >= 1) {
    if (value[currentPath] === undefined) {
      if (pathList[0].match(/^\d+$/)) {
        Vue.set(value, currentPath, []);
      } else {
        Vue.set(value, currentPath, {});
      }
    }
    value = value[currentPath];
    currentPath = pathList.shift();
  }
  if ($event.delete) {
    Vue.delete(value, currentPath as any);
  } else {
    Vue.set(value, currentPath as any, $event.value);
  }
}

export function getEntityNameFormatter(entity: string | Function) {
  const blueprint = DataUiBlueprints.get(entity);
  let formatter;
  if (blueprint.name?.nameFunction) {
    formatter = blueprint.name?.nameFunction;
  } else if (blueprint.name?.nameProperties?.length) {
    const props = blueprint.name?.nameProperties;
    formatter = (item) => props.map((prop) => _.get(item, prop)).join(' ');
  } else {
    formatter = (item) => item?.id;
  }
  return formatter;
}

export function getRelationNameFormatter(config: DataUiColumnDescription) {
  console.assert(config.isRelation);
  let formatter = getEntityNameFormatter(config.relationEntity);
  if (
    config.relationType === SimplifiedRelationType.ONE_TO_MANY ||
    config.relationType === SimplifiedRelationType.MANY_TO_MANY
  ) {
    const singleItemFormatter = formatter;
    formatter = (item) => item?.map(singleItemFormatter).join(', ');
  }
  return formatter;
}
